













































import { Vue, Component, Prop } from 'vue-property-decorator'

import Footer from '@/components/commons/Footer.vue'
import GenericPage from './GenericPage.vue'
import { authStore } from '@/store'
import Magistrados from '@/components/admin/magistrados/Magistrados.vue'
import Expedientes from '@/components/admin/expedientes/Expedientes.vue'
import Configuraciones from '@/components/admin/configs/Configuraciones.vue'
import Denuncias from '@/components/admin/denuncias/Denuncias.vue'

@Component({
  components: {
    Footer,
    GenericPage,
    Magistrados,
    Expedientes,
    Denuncias,
    Configuraciones,
  },
})
export default class AdminPage extends Vue {
  @Prop()
  tipo: string
  /** Store de Auth */
  private get authStore() {
    return authStore
  }

  /** User de Keycloak */
  private get user() {
    return authStore.user
  }
  private get urlMagistrados() {
    return this.$route.path.search('/magistrados') !== -1
  }
  private get urlExpedientes() {
    return this.$route.path.search('/expedientes') !== -1
  }
  private get urlDenuncias() {
    return this.$route.path.search('/denuncias') !== -1
  }
  private get urlAdmin() {
    return this.$route.path.search('/admin') !== -1
  }
  private get urlConfig() {
    return this.$route.path.search('/config') !== -1
  }
}
